import { httpClient, mountUrl } from '@/httpClient'

const BASE_URL = '/api/v1/sites/$siteId/domains'
const DOMAIN_URL = `${BASE_URL}/$domainId`

export const findAll = ({ siteId }) => httpClient.get(mountUrl(BASE_URL, { siteId }))

export const create = ({ siteId, domain }) => httpClient.post(mountUrl(BASE_URL, { siteId }), domain)

export const update = (siteId, domain) => httpClient.put(mountUrl(DOMAIN_URL, { siteId, domainId: domain.id }), domain)

export const remove = ({ siteId, domainId }) => httpClient.delete(mountUrl(DOMAIN_URL, { siteId, domainId }))
